import PriceList from "@/models/PriceList";
import moment from "moment";
import PriceListItem from "@/models/PriceListItem";
import ProductType from "@/models/ProductType";
import Product from "@/models/Product";
import InsulationCut from "@/models/InsulationCut";
import ProductCategory from "@/models/ProductCategory";
import DocumentPreview from "@/components/documents/DocumentPreview";

import _ from 'lodash';

export default {
    components: {DocumentPreview},
    data () {
        return {
            price_list_product_types: null,
            current_price_lists: [],
            upcoming_price_lists: [],
            customer_items: [],
            groups: [],

            sorted: null,
            additional: null,
            
            fields: {
                Blocks: [
                    { key: 'preview', label: 'Preview' },
                    { key: 'spec', label: 'Spec.' },
                    { key: 'product_number', label: 'Item #' },
                    { key: 'product_name', label: 'Insulated Concrete Forms' },
                    { key: 'price', _classes: 'text-right' },
                ],
                Insulation: [
                    { key: 'preview', label: 'Preview' },
                    { key: 'spec', label: 'Spec.' },
                    { key: 'product_cut_name', label: 'Insulation' },
                    { key: 'price' },
                ],
                Accessories: [
                    { key: 'preview', label: 'Preview' },
                    { key: 'spec', label: 'Spec.' },
                    { key: 'product_number', label: 'Item #' },
                    { key: 'product_name', label: 'Accessories' },
                    { key: 'price' },
                ],
                defaults: [
                    { key: 'preview', label: 'Preview' },
                    { key: 'spec', label: 'Spec.' },
                    { key: 'product_number', label: 'Item #' },
                    { key: 'product_name', label: 'Product' },
                    { key: 'price' },
                ]
            },
        }
    },
    methods: {
        calculatePrice(item) {
            const productInPriceList = this.productListForCustomer[item.product_id] || { cost: 0 };
            return Number(productInPriceList.cost) * Number(item.quantity)
        },
        fetchPriceLists() {
            this.loading = true;
            let requests = [
                PriceList.api().fetch({limit: 999}),
                PriceListItem.api().fetch({customer_id: this.$store.getters.getAuthCustomerID, limit: 999}),
            ];

            Promise.all(requests).then((res) => {

                let res_pls = res[0].entities[PriceList.entity];
                let all_ids = res_pls && res_pls.length ? res_pls.map(i=>i.id) : [];

                let dt = moment();
                
                let current_price_lists = PriceList.query()
                .whereIdIn(all_ids)
                .where('active_start', value => moment(value).isSameOrBefore(dt))
                .where('active_end', value => (value === null || moment(value).isSameOrAfter(dt)))
                .orderBy('active_start', 'desc')
                .get() || [];

                let upcoming_price_lists = PriceList.query()
                .whereIdIn(all_ids)
                .where('active_start', value => moment(value).isAfter(dt))
                .where('active_end', value => (value === null || moment(value).isSameOrAfter(dt)))
                .orderBy('active_start', 'desc')
                .get() || [];

                if((!current_price_lists || !current_price_lists.length) && (!upcoming_price_lists|| !upcoming_price_lists.length)) {
                    this.$refs.loadingProgress.done();
                    this.loading = false;
                    return;
                }

                let upcoming_dates = [];
                upcoming_price_lists.forEach(i => {
                    let start_dt = moment(i.active_start);
                    let found = upcoming_dates.find(j => j === start_dt.format('LL'));
                    if(!found) {
                        upcoming_dates.push(start_dt.format('LL'));
                    }
                });

                let price_list_ids = [
                    current_price_lists.map(i=>i.id) || [],
                    upcoming_price_lists.map(i=>i.id) || []
                ].flat();

                Promise.all([
                    PriceListItem.api().fetch({price_list_id: price_list_ids.join('|'), limit: 9999}),
                    ProductType.api().fetch({limit: 9999}),
                    Product.api().fetch({limit: 9999}),
                    ProductCategory.api().fetch({limit: 9999}),
                ]).then((results) => {
                    let insulation = [];
                    results[2].entities.products.forEach((product) => {
                        if(product.insulation_cut_id) {
                        insulation.push(product.insulation_cut_id);
                        }
                    });

                    InsulationCut.api().fetch({id: insulation.join('|')}).then(() => {
                        this.price_list_product_types = ProductType.query().with('product_categories').get();
                        this.current_price_lists = PriceList.query()
                            .whereIdIn(current_price_lists.map(i=>i.id) || [])
                            .where('active_end', value => (value === null || moment(value).isSameOrAfter(dt)))
                            .orderBy('active_start', 'desc')
                            .with([
                            'price_list_items',
                            'price_list_items.product',
                            'price_list_items.insulation_cut',
                            'price_list_items.product.product_type',
                            'price_list_items.product.product_category',
                            'price_list_items.product.images',
                            'price_list_items.product.specifications'
                            ]).get();

                        this.upcoming_price_lists = [];
                        upcoming_dates.forEach(i => {
                        let tmp = moment(i);

                        this.upcoming_price_lists.push({
                            date: i,
                            lists: PriceList.query()
                            .where('active_start', (value) => moment(value).isSameOrBefore(tmp))
                            .where('active_end', value => (value === null || moment(value).isSameOrAfter(tmp)))
                            .orderBy('active_start', 'desc')
                            .with([
                            'price_list_items',
                            'price_list_items.product',
                            'price_list_items.insulation_cut',
                            'price_list_items.product.product_type',
                            'price_list_items.product.product_category',
                            'price_list_items.product.images',
                            'price_list_items.product.specifications'
                            ]).get()
                        });
                    });

                    this.customer_items = PriceListItem.query().where('customer_id', +(this.$store.getters.getAuthCustomerID)).with([
                        'product',
                        'insulation_cut',
                        'product.product_type',
                        'product.product_category',
                        'product.images',
                        'product.specifications'
                        ]).get();

                    this.groups = ['Current', ...this.upcoming_price_lists.map(i=>i.date)];
                    
                    let sorted = {};
                    let additional = {};

                    [
                        {
                            date: 'Current',
                            lists: [...this.current_price_lists]
                        },
                        this.upcoming_price_lists
                    ].flat().forEach(i => {
                        i.lists.map(j => j.price_list_items).flat().forEach((item) => {
                            if(item.custom) {
                            if(!additional[i.date]) {
                                additional[i.date] = [];
                            }
                            if(!additional[i.date].find(p => p.id === item.id)) {
                                additional[i.date].push(item);
                            }
                            } else if(item.product && item.product.product_type && item.product.product_category) {
                            if(!sorted[i.date]) {
                                sorted[i.date] = {};
                            }
                            if(!sorted[i.date][item.product.product_type.id]) {
                                sorted[i.date][item.product.product_type.id] = {};
                            }
                            if(!sorted[i.date][item.product.product_type.id][item.product.product_category.id]) {
                                sorted[i.date][item.product.product_type.id][item.product.product_category.id] = [];
                            }
                            sorted[i.date][item.product.product_type.id][item.product.product_category.id].push(item);
                            }
                        });

                        this.groups.forEach(g => {
                            this.customer_items.forEach((item) => {
                            if(item.custom) {
                                if(!additional[g]) {
                                additional[g] = [];
                                }
                                if(!additional[i.date].find(p => p.id === item.id)) {
                                additional[i.date].push(item);
                                }
                            } else if(item.product && item.product.product_type && item.product.product_category) {
                                if(!sorted[g]) {
                                sorted[g] = {};
                                }
                                if(!sorted[g][item.product.product_type.id]) {
                                sorted[g][item.product.product_type.id] = {};
                                }
                                if(!sorted[g][item.product.product_type.id][item.product.product_category.id]) {
                                sorted[g][item.product.product_type.id][item.product.product_category.id] = [];
                                }
                                if(item.product.product_type.name === 'Blocks' || item.product.product_type.name === 'Accessories') {
                                let found = sorted[g][item.product.product_type.id][item.product.product_category.id].findIndex((i) => {
                                    return (i.product && item.product) && i.product.id === item.product.id;
                                });
                                if(found !== -1) {
                                    sorted[g][item.product.product_type.id][item.product.product_category.id].splice(found, 1, item);
                                } else {
                                    sorted[g][item.product.product_type.id][item.product.product_category.id].push(item);
                                }
                                } else {
                                sorted[g][item.product.product_type.id][item.product.product_category.id].push(item);
                                }
                            }
                            });
                        });
                    });
                    
                    for(let group in sorted) {
                        for(let type_id in sorted[group]) {
                            for(let cat_id in sorted[group][type_id]) {
                            sorted[group][type_id][cat_id].sort((a, b) => ((a.product && a.product.number ? Math.abs(a.product.number) : 99999) > (b.product && b.product.number ? Math.abs(b.product.number) : 99999)) ? 1 : -1);
                            }
                        }
                    }

                    this.sorted = sorted;
                    this.additional = additional;
                    this.loading = false;
                });
                });
            });
        }
    },
    mounted() {
        this.fetchPriceLists();
    },
    computed: {
        productListForCustomer() {
            const productList = _.flatMap(this.current_price_lists, (priceList) => { return priceList.price_list_items });

            const productListKeyedByProductId = _.keyBy(productList, (product) => { return product.product_id });
            _.forEach(this.customer_items, (item) => {
                productListKeyedByProductId[item.product_id] = item
            });
            
            return productListKeyedByProductId;
        }
    }
}